// extracted by mini-css-extract-plugin
export default {"title":"SideNavigation_title__JmlGt","links":"SideNavigation_links__HIy81","nav":"SideNavigation_nav__W3tNQ"};